import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, NewsletterDTO } from "../api";
import Builder from "../builder/Builder";
import { Doc } from "../builder/types";
import { printNewsletter } from "../print";

export default function ReadNewsletter() {
  const { slug } = useParams();
  const [nl, setNl] = useState<NewsletterDTO | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [theme, setTheme] = useState<"dark" | "light">(() => (localStorage.getItem("vox-theme") as any) || "dark");

  useEffect(() => {
    if (!slug) return;
    api.getNewsletterBySlug(slug).then(setNl).catch((e) => setErr(e.message));
  }, [slug]);

  const setThemePersist = (t: "dark" | "light") => {
    setTheme(t);
    localStorage.setItem("vox-theme", t);
  };

  if (err)
    return (
      <div className="page-wrap" style={{ textAlign: "center" }}>
        <p style={{ color: "var(--accent)" }}>{err}</p>
        <Link to="/" className="btn">
          ← Back to issues
        </Link>
      </div>
    );
  if (!nl) return <div className="mono" style={{ padding: 60, textAlign: "center", color: "var(--muted)", fontSize: 12 }}>Loading…</div>;

  const doc: Doc = { head: nl.head, blocks: nl.blocks };

  return (
    <div>
      <div className="no-print" style={{ maxWidth: 960, margin: "0 auto", display: "flex", gap: 10, padding: "12px 20px", justifyContent: "flex-end" }}>
        {nl.status === "draft" && (
          <span className="mono" style={{ fontSize: 10.5, color: "var(--gold)", alignSelf: "center", marginRight: "auto", textTransform: "uppercase", letterSpacing: ".1em" }}>
            Draft preview
          </span>
        )}
        <button className="btn" onClick={() => setThemePersist(theme === "dark" ? "light" : "dark")}>
          {theme === "dark" ? "Light" : "Dark"}
        </button>
        <button className="btn btn-accent" onClick={() => printNewsletter(theme)}>
          ⎙ Print / PDF
        </button>
      </div>
      <Builder doc={doc} variant="newsletter" mode="read" theme={theme} onChange={() => {}} />
    </div>
  );
}
